/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Phase2_Fix_Call_Sample_OtherInputs */

const en_phase2_fix_call_sample_other = /** @type {(inputs: Phase2_Fix_Call_Sample_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} calls`)
};

const zh_hans1_phase2_fix_call_sample_other = /** @type {(inputs: Phase2_Fix_Call_Sample_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 次调用`)
};

const pt_br2_phase2_fix_call_sample_other = /** @type {(inputs: Phase2_Fix_Call_Sample_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} chamadas`)
};

const es_phase2_fix_call_sample_other = /** @type {(inputs: Phase2_Fix_Call_Sample_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} llamadas`)
};

const fr_phase2_fix_call_sample_other = /** @type {(inputs: Phase2_Fix_Call_Sample_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} appels`)
};

const de_phase2_fix_call_sample_other = /** @type {(inputs: Phase2_Fix_Call_Sample_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Aufrufe`)
};

const ru_phase2_fix_call_sample_other = /** @type {(inputs: Phase2_Fix_Call_Sample_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Вызовов: ${i?.count}`)
};

const it_phase2_fix_call_sample_other = /** @type {(inputs: Phase2_Fix_Call_Sample_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} chiamate`)
};

/**
* | output |
* | --- |
* | "{count} calls" |
*
* @param {Phase2_Fix_Call_Sample_OtherInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const phase2_fix_call_sample_other = /** @type {((inputs: Phase2_Fix_Call_Sample_OtherInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Phase2_Fix_Call_Sample_OtherInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_phase2_fix_call_sample_other(inputs)
	if (locale === "pt-BR") return pt_br2_phase2_fix_call_sample_other(inputs)
	if (locale === "es") return es_phase2_fix_call_sample_other(inputs)
	if (locale === "fr") return fr_phase2_fix_call_sample_other(inputs)
	if (locale === "de") return de_phase2_fix_call_sample_other(inputs)
	if (locale === "ru") return ru_phase2_fix_call_sample_other(inputs)
	if (locale === "it") return it_phase2_fix_call_sample_other(inputs)
	return en_phase2_fix_call_sample_other(inputs)
});